import { Injectable } from '@angular/core';
import { OrderItemsStore } from './entities/order-items/order-items.store';
import { OrderItemsQuery } from './entities/order-items/order-items.query';
import { StoreInterface } from '../interfaces/store.interface';

@Injectable({ providedIn: 'root' })
export class OrderItemsStoreService {
  private stores = new Map();

  constructor() {}

  getOrCreateStore(name: string): StoreInterface<OrderItemsStore, OrderItemsQuery> {
    if (!name) {
      return;
    }
    if (this.stores.has(name)) {
      return this.getState(name);
    } else {
      const store = new OrderItemsStore(name);
      const query = new OrderItemsQuery(store);

      const state = { store, query };
      this.stores.set(name, state);
      return state;
    }
  }

  private getState(name: string) {
    return this.stores.get(name);
  }
}
